import { BaseApiService } from "../base/base-api.service";
import { LegalEntityLoanDTO, LegalEntityLoanSTO } from "../../models/legal-entity-loans";
import { LegalEntityLoansTotalDTO } from "../../models/legal-entity-loans/legal-entity-loans-total-dto";
import { LegalEntityLoansTotalFilter } from "../../models/legal-entity-loans/legal-entity-loans-total-filter";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { Response } from "../../models/api/response";
import { LoadResponse } from "src/models/api/load";

export class LegalEntityLoansApiService extends BaseApiService<LegalEntityLoanDTO, LegalEntityLoanSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityLoans",
      loadItemsPath: "/GetLegalEntityLoans",
      saveItemsPath: "/SaveLegalEntityLoans",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadLegalEntityLoansTotals = async (
  propsFilter: LegalEntityLoansTotalFilter,
  signal?: AbortSignal
): Promise<Response & { items: LegalEntityLoansTotalDTO[] }> => {
  const service = new LegalEntityLoansApiService();
  service.useLoadItemsPath("/GetLegalEntityLoansTotals");

  const response = await service.loadItems(propsFilter, undefined, undefined, undefined, undefined, 60, signal);

  return response as unknown as LoadResponse<LegalEntityLoansTotalDTO>;
};
